module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point1_3-222022e1022da20972e44577a63f41b0.jpg";